import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useCallback,
} from "react";
import TopCard from "../../components/card/TopCard";
import CustomTable from "../../components/table/CustomTable";
import { GoPlus } from "react-icons/go";
import useTransaction from "../../hooks/useTransaction";
import { getLga, getState } from "../../ds/resource";
import useOutsideClick from "../../hooks/useOutsideClick";
import { toMoney, toMoneyDecimal } from "../../utils/utils";
import Modal from "../../components/Modal";
import ViewDetail from "../../components/modal/ViewDetail";
import PaginationPane from "../../components/table/PaginationPane";
import { TransactionModal } from "../../components/modal/TransactionModal";
import useAggregator from "../../hooks/useAggregator";
import useCollector from "../../hooks/useCollector";
import SearchableDropdown from "../../components/input/SearchableDropdown";
import { MdDelete } from "react-icons/md";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import Character from "../../assets/images/Character.png";

//date range
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import DeleteModal from "../../components/modal/DeleteModal";
import toast from "react-hot-toast";
import DataCard from "../../components/card/DataCard";
import { gatOneSetting, readFeatureForUser } from "../../ds/settings";
import DeleteFalseModal from "../../components/modal/DeleteFalseModal";

const headers = [
  "Aggregators",
  "Collectors",
  "Collector's Gender",
  "Price",
  "Quantity(KG)",
  "Amount",
  "State",
  "Transaction Date",
  "Entry Date",
];
const headers3 = [
  "Aggregators",
  "Collectors",
  "Collector's Gender",
  "Quantity(KG)",
  "Amount",
  "State",
  "Transaction Date",
  "Entry Date",
];
const headers2 = [
  "Collectors",
  "Collector's Gender",
  "Price",
  "Quantity",
  "Amount",
  "State",
  "Transaction Date",
  "Entry Date",
];

const Collection = () => {
  const wrapperRef = useRef(null);
  const [query, setQuery] = useState("");
  const [selectedState, setSelectedState] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [transactionDetail, setTransactionDetail] = useState({});
  const [states, setStates] = useState([]);
  const [lga, setLga] = useState([]);
  const [aggregatorList, setAggregatorList] = useState([]);
  const [aggId, setAggId] = useState(null);
  const [collectionTarget, setCollectionTarget] = useState(0);
  const [aggGender, setAggGender] = useState(null);

  const [collectorList, setCollectorList] = useState([]);
  const [colId, setColId] = useState(null);
  const [page, setPage] = useState(1);
  const [showModal, setShowModal] = useOutsideClick(wrapperRef);
  const [viewDetail, setViewDetail] = useOutsideClick(wrapperRef);
  const [editDetail, setEditDetail] = useOutsideClick(wrapperRef);
  const [showDeleteModal, setShowDeleteModal] = useOutsideClick(wrapperRef);
  const [showDeleteFalseModal, setShowDeleteFalseModal] =
    useOutsideClick(wrapperRef);
  const [showEditFalseModal, setShowEditFalseModal] =
    useOutsideClick(wrapperRef);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [totalQty, setTotalQty] = useState(0);
  const [canDelete, setCanDelete] = useState({});
  const [canShowNewCollection, setCanShowNewCollection] = useState(null);
  const [canActivateEditTransaction, setCanActivateEditTransaction] =
    useState(null);

  const [userId, setUserId] = useState(0);
  const { program, user } = useSelector((state) => state.auth);
  const accountId = user?.id ?? user?.userId;

  const limit = 10;

  const { gatAllAggregatorLists } = useAggregator();
  const { gatAllCollectorList } = useCollector();
  const {
    loading,
    getTransactions,
    deleteOneTransaction,
    transactionDownload,
  } = useTransaction();

  //for date range
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [formatStartDate, setFormatStartDate] = useState(null);
  const [formatEndDate, setFormatEndDate] = useState(null);

  const onChange = (dates) => {
    const [start, end] = dates;

    setStartDate(start);
    setEndDate(end);

    {
      start
        ? setFormatStartDate(moment(start).format("YYYY-MM-DD"))
        : setFormatStartDate(null);
    }

    {
      end
        ? setFormatEndDate(moment(end).format("YYYY-MM-DD"))
        : setFormatEndDate(null);
    }
  };

  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className="flex flex-col gap-2">
      <div
        className="example-custom-input border border-gray-300 h-[44px] w-[260px] md:w-[170px] lg:w-[280px] p-2 rounded-md"
        onClick={onClick}
        ref={ref}
      >
        <h3>{value ? value : "Select date range"}</h3>
      </div>
    </div>
  ));

  //fetch transactions
  const fetchTransactions = useCallback(
    async (
      newQuery,
      selState,
      newaggId,
      colectorId,
      formatStaDate,
      formatEdDate,
      genderState,
    ) => {
      const queryData = query || newQuery;
      const newState = selectedState?.value || selState?.value;
      const newCol = colId?.value || colectorId?.value;
      const newAgg = aggId?.value || newaggId?.value;
      const newEdDate = formatEndDate || formatEdDate;
      const newStaDate = formatStartDate || formatStaDate;
      const genderData = aggGender?.value || genderState?.value;

      const res = await getTransactions(
        page,
        limit,
        queryData,
        newState,
        newAgg,
        newCol,
        newStaDate,
        newEdDate,
        program,
        genderData,
      );
      setTotalPages(res?.data?.totalPages);
      setCollectionTarget(res?.data?.transactionSummary.target);
      setTotalElements(res?.data?.totalElements);
      setTotalQty(res?.data?.transactionSummary.totalQuantity);
      setTransactions(res?.data?.content);
    },
    [page, program],
  );

  useEffect(() => {
    fetchTransactions();
  }, [fetchTransactions, page, program]);

  useEffect(() => {
    const getAggregatorsList = async () => {
      const res = await gatAllAggregatorLists(program);
      const list = JSON.parse(res)?.data?.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setAggregatorList([...list]);
    };

    const getCollectorsList = async () => {
      const res = await gatAllCollectorList(program);
      const list = JSON.parse(res)?.data?.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setCollectorList([...list]);
    };

    getAggregatorsList();
    getCollectorsList();
  }, [program]);
  const handleDelete = (id) => {
    deleteOneTransaction(id);
    setTimeout(() => {
      fetchTransactions();
    }, 1000);
    toast.success("Deleted succesfully");
  };
  const reset = () => {
    setAggId(null);
    setColId(null);
    setSelectedState(null);
    setPage(1);
    setStartDate("");
    setEndDate("");
    fetchTransactions();
    setAggGender(null);
  };
  useEffect(() => {
    const getAllState = async () => {
      const res = await getState(program);
      const list = JSON.parse(res).data.map((item) => {
        return {
          label: item.name,
          value: item.name,
        };
      });

      setStates([...list]);
    };
    getAllState();
  }, []);

  useEffect(() => {
    const getAllLga = async () => {
      const res = await getLga();
      setLga(res.data);

      const list = res.data.map((item) => {
        return {
          label: item.name,
          value: item.name,
        };
      });
      setLga([...list]);
    };
    getAllLga();
  }, []);

  useEffect(() => {
    const getSetting = async () => {
      const enabled = await readFeatureForUser(
        "CAN_DELETE_RECORD",
        "CAN_DELETE_RECORD_USERS",
        accountId,
      );
      setCanDelete(enabled);
    };
    getSetting();
  }, [accountId]);

  useEffect(() => {
    const getSetting = async () => {
      const res = await gatOneSetting({ type: "DEACTIVATE_TRANSACTION" });
      setCanShowNewCollection(JSON.parse(res?.data?.value));
    };
    getSetting();
  }, []);

  useEffect(() => {
    const getSetting = async () => {
      const enabled = await readFeatureForUser(
        "ACTIVATE_EDIT_TRANSACTION",
        "ACTIVATE_EDIT_TRANSACTION_USERS",
        accountId,
      );
      setCanActivateEditTransaction(enabled);
    };
    getSetting();
  }, [accountId]);

  const nextPage = () => {
    setPage((prev) => (prev >= totalPages ? 1 : prev + 1));
    fetchTransactions(
      query,
      selectedState,
      aggId,
      colId,
      formatStartDate,
      formatEndDate,
    );
  };
  const prevPage = () => {
    setPage((prev) => (prev > 1 ? prev - 1 : prev));
    fetchTransactions(
      query,
      selectedState,
      aggId,
      colId,
      formatStartDate,
      formatEndDate,
    );
  };
  const isAggregator = user.userType === "AGGREGATOR";
  const canShowEdit = user?.userType !== "PARTNER";

  const dataHeaders =
    user?.userType !== "AGGREGATOR" && program === 1
      ? headers
      : program === 2 || program === 3
        ? headers3
        : headers2;
  const tableHeaders = canShowEdit ? [...dataHeaders, ""] : dataHeaders;

  const handleEdit = (data) => {
    setTransactionDetail(data);
    if (canActivateEditTransaction) {
      setEditDetail(true);
    }
    if (!canActivateEditTransaction) {
      setShowEditFalseModal(true);
    }
  };

  const getRowActions = (data, index) => {
    const actions = {
      open: (
        <MdOutlineRemoveRedEye
          key={`view-${index}`}
          onClick={() => {
            setViewDetail(true);
            setTransactionDetail(data);
          }}
        />
      ),
    };

    if (canShowEdit) {
      actions.edit = (
        <FiEdit
          key={`edit-${index}`}
          onClick={() => handleEdit(data)}
        />
      );
    }

    actions.delete = user?.userType !== "PARTNER" && (
      <MdDelete
        key={`delete-${index}`}
        width={30}
        onClick={() => {
          if (canDelete) {
            setUserId(data.id);
            setShowDeleteModal(true);
          }
          if (!canDelete) {
            setShowDeleteFalseModal(true);
          }
        }}
      />
    );

    return actions;
  };

  return (
    <div className="p-4">
      <div className="mb-10">
        <TopCard
          title={"Collections"}
          subtitle={"List of collections on the platform."}
          buttonTitle={"New Collections"}
          Icon={GoPlus}
          setShowModal={() => setShowModal(true)}
          exportType="transaction"
          userType={user?.userType}
          downloadData={() =>
            transactionDownload({
              collectorId: colId?.value,
              aggregatorId: aggId?.value,
              selectedState: selectedState?.value,
              startDate,
              endDate,
              program,
            })
          }
        />
      </div>
      <div className="flex gap-[20px] mb-10">
        <DataCard
          css={"bg-[#FFFAEB] w-[100%]"}
          image={Character}
          title={"Total Collections"}
          subtitle={toMoney(totalQty) || 0}
        />
        <DataCard
          css={"bg-[#FFFFFF] w-[100%] border border-gray-300"}
          image={Character}
          title={"Collection Target"}
          subtitle={toMoney(collectionTarget) || 0}
        />
      </div>
      <div className="mb-10 flex flex-col justify-between md:flex-row lg:flex-row gap-2">
        <div className="flex flex-wrap gap-4 md:gap-2 lg:gap-2">
          <SearchableDropdown
            options={aggregatorList || []}
            dropDownStyle={{ display: isAggregator ? "none" : "block" }}
            selectedOption={aggId}
            defaultValue={null}
            placeholder="Filter by aggregator"
            handleChange={(e) => {
              setAggId(e);
            }}
          />
          <SearchableDropdown
            options={[
              {
                label: "Male",
                value: "Male",
              },
              {
                label: "Female",
                value: "Female",
              },
            ]}
            selectedOption={aggGender}
            defaultValue={null}
            placeholder="Filter by Gender"
            handleChange={(value) => {
              setAggGender(value);
            }}
          />
          <SearchableDropdown
            options={collectorList || []}
            selectedOption={colId}
            defaultValue={null}
            placeholder="Filter by collector"
            handleChange={(value) => {
              setColId(value);
            }}
          />
          <SearchableDropdown
            options={states || []}
            selectedOption={selectedState}
            defaultValue={null}
            placeholder="Filter by state"
            handleChange={(e) => {
              setSelectedState(e);
            }}
          />
        </div>
        <div className="flex lg:flex-row lg:flex-nowrap gap-2">
          <DatePicker
            selected={startDate}
            onChange={onChange}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            customInput={<ExampleCustomInput />}
            showYearDropdown
            yearDropdownItemNumber={100}
            scrollableYearDropdown
            isClearable
          />
          <button
            className="flex justify-center items-center h-[44px] w-[80px] lg:w-[101px] border border-gray-300 gap-2 rounded-md"
            onClick={() => {
              fetchTransactions(
                query,
                selectedState,
                aggId,
                colId,
                formatStartDate,
                formatEndDate,
                aggGender,
              );
            }}
          >
            Apply
          </button>
          <button
            className="flex justify-center items-center h-[44px] w-[60px] border border-gray-300 gap-2 rounded-md"
            onClick={() => reset()}
          >
            refresh
          </button>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center">
          <p className="text-center">Loading...</p>
        </div>
      ) : transactions?.length === 0 ? (
        <div className="flex justify-center">
          <p className="text-center">No data.</p>
        </div>
      ) : (
        <CustomTable
          headers={tableHeaders}
          rows={
            user?.userType !== "AGGREGATOR" && program === 1
              ? transactions?.map((data, index) => {
                return {
                  aggregator: data.aggregator,
                  collector: data.collector,
                  gender: data?.gender,
                  price: "NGN " + toMoney(data.price),
                  quantity: toMoneyDecimal(data.quantity),
                  amount: "NGN " + toMoney(data.amount),
                  state: data.state,
                  transactionDate: data?.transactionDate,
                  date: data.createdAt,
                  ...getRowActions(data, index),
                };
              })
              : (program === 2 || program === 3)
                ? transactions?.map((data, index) => {
                  return {
                    aggregator: data.aggregator,
                    collector: data.collector,
                    gender: data?.gender,
                    quantity: toMoneyDecimal(data.quantity),
                    amount: "NGN " + toMoney(data.amount),
                    state: data.state,
                    transactionDate: data?.transactionDate,
                    date: data.createdAt,
                    ...getRowActions(data, index),
                  };
                })
                : transactions?.map((data, index) => {
                  return {
                    collector: data.collector,
                    gender: data?.gender,
                    price: "NGN " + toMoney(data.price),
                    quantity: toMoneyDecimal(data.quantity),
                    amount: "NGN " + toMoneyDecimal(data.amount),
                    state: data.state,
                    transactionDate: data?.transactionDate,
                    date: data.createdAt,
                    ...getRowActions(data, index),
                  };
                })
          }
        />
      )}

      <PaginationPane
        currentPage={page > 1 ? page : 1}
        totalPages={totalPages || 1}
        nextPage={() => nextPage()}
        prevPage={() => prevPage()}
      />
      {showModal && !canShowNewCollection && (
        <Modal
          variant="default"
          refProp={wrapperRef}
          closeModal={() => setShowModal(false)}
        >
          <TransactionModal
            closeModal={() => setShowModal(false)}
            aggregatorList={aggregatorList}
            collectorList={collectorList}
            fetchTransactions={fetchTransactions}
            isAggregator={isAggregator}
            selectOptDefault={{ label: user.name, value: user?.aggregatorId }}
          />{" "}
        </Modal>
      )}
      {showModal && canShowNewCollection && (
        <Modal
          variant="default"
          refProp={wrapperRef}
          closeModal={() => setShowModal(false)}
        >
          <DeleteFalseModal
            closeModal={() => setShowModal(false)}
            msg={"Feature disabled, please contact admin"}
          />
        </Modal>
      )}
      {editDetail && (
        <Modal
          variant="default"
          refProp={wrapperRef}
          closeModal={() => setEditDetail(false)}
        >
          <TransactionModal
            closeModal={() => setEditDetail(false)}
            requestType={"edit"}
            userData={transactionDetail}
            aggregatorList={aggregatorList}
            collectorList={collectorList}
            fetchTransactions={fetchTransactions}
            isAggregator={isAggregator}
            selectOptDefault={{ label: user.name, value: user?.aggregatorId }}
          />
        </Modal>
      )}
      {viewDetail && (
        <Modal
          variant="default"
          refProp={wrapperRef}
          closeModal={() => setViewDetail(false)}
        >
          <ViewDetail
            detail={
              user.userType !== "AGGREGATOR"
                ? {
                  aggregator: transactionDetail?.aggregator
                    ? transactionDetail?.aggregator
                    : "N/A",
                  collector: transactionDetail?.collector
                    ? transactionDetail?.collector
                    : "N/A",
                  state: transactionDetail?.state
                    ? transactionDetail?.state
                    : "N/A",
                  "Type Of Plastic": transactionDetail?.typeOfPlastic
                    ? transactionDetail?.typeOfPlastic
                    : "N/A",
                  "Source Of Plastic": transactionDetail?.sourceOfPlastic
                    ? transactionDetail?.sourceOfPlastic
                    : "N/A",
                  "quantity(Kg)": transactionDetail?.quantity
                    ? toMoney(transactionDetail?.quantity)
                    : 0,
                  "price(NGN)": transactionDetail?.price
                    ? toMoney(transactionDetail?.price)
                    : 0,
                  "amount(NGN)": transactionDetail?.amount
                    ? toMoney(transactionDetail?.amount)
                    : 0,
                }
                : {
                  collector: transactionDetail?.collector
                    ? transactionDetail?.collector
                    : "N/A",
                  state: transactionDetail?.state
                    ? transactionDetail?.state
                    : "N/A",
                  "Type Of Plastic": transactionDetail?.typeOfPlastic
                    ? transactionDetail?.typeOfPlastic
                    : "N/A",
                  "Source Of Plastic": transactionDetail?.sourceOfPlastic
                    ? transactionDetail?.sourceOfPlastic
                    : "N/A",
                  "quantity(Kg)": transactionDetail?.quantity
                    ? toMoney(transactionDetail?.quantity)
                    : 0,
                  "price(NGN)": transactionDetail?.price
                    ? toMoney(transactionDetail?.price)
                    : 0,
                  "amount(NGN)": transactionDetail?.amount
                    ? toMoney(transactionDetail?.amount)
                    : 0,
                }
            }
            closeModal={() => setViewDetail(false)}
            title={"Transaction Details"}
            subtitle={"Transaction details below"}
            dateCreated={"14 January 2024"}
            editbutton={canShowEdit}
            onEdit={() => {
              setViewDetail(false);
              handleEdit(transactionDetail);
            }}
            createdAt={transactionDetail.createdAt}
          />
        </Modal>
      )}
      {showDeleteModal && (
        <Modal
          variant="default"
          refProp={wrapperRef}
          closeModal={() => setShowDeleteModal(false)}
        >
          <DeleteModal
            closeModal={() => setShowDeleteModal(false)}
            handleDelete={() => handleDelete(userId)}
          />
        </Modal>
      )}
      {showDeleteFalseModal && (
        <Modal
          variant="default"
          refProp={wrapperRef}
          closeModal={() => setShowDeleteFalseModal(false)}
        >
          <DeleteFalseModal
            closeModal={() => setShowDeleteFalseModal(false)}
            msg={"Cannot delete record. Please contact admin."}
          />
        </Modal>
      )}
      {showEditFalseModal && (
        <Modal
          variant="default"
          refProp={wrapperRef}
          closeModal={() => setShowEditFalseModal(false)}
        >
          <DeleteFalseModal
            closeModal={() => setShowEditFalseModal(false)}
            msg={"Cannot Edit record. Please contact admin."}
          />
        </Modal>
      )}
    </div>
  );
};

export default Collection;
